import ParentPortal from "@/pages/ParentPortal";

export default function PlayerPortal() {
  return <ParentPortal mode="player" />;
}
